<template>
  <div class="participants">
    <div class="box-row">
      <span class="box-row-title">{{ participantOption.title }}</span>
      <div class="counter-container">
        <button v-on:click="setCounter((participantOption.amount || 0) - 1)" class="counter-button">-</button>
        <span class="counter-num">{{ participantOption.amount || 0 }}</span>
        <button v-on:click="setCounter((participantOption.amount || 0) + 1)" class="counter-button">+</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ParticipantAmount',
  props: {
    participantOption: Object,
    occupancySum: Number,
    maxOccupancy: Number,
    getTranslation: Function
  },
  methods: {
    setCounter: function (num) {
      if (num < 0) {
        return
      }
      /* if ((this.participantOption.occupancy * (num > this.participantOption.amount ? 1 : -1) + this.occupancySum) > this.maxOccupancy) {
        return
      } */
      this.$emit(
        'update-calender',
        {
          participants: {
            [this.participantOption.id]: {
              amount: num,
              masterCategoryId: this.participantOption.masterCategoryId,
              id: this.participantOption.id,
              title: this.participantOption.title,
              occupancy: this.participantOption.occupancy,
              isGroup: this.participantOption.ticketCategory === 'GROUP',
              groupSize: this.participantOption.groupSize
            }
          }
        }
      )
      this.$emit('update-cart', [{}, '', 0])

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.participants {
  margin-bottom: -1px;
  padding: 15px;
  padding-bottom: 0px;
  padding-top: 0px;
}
.counter-button {
  background-color: white;
  border: 0px solid white;
  color: #0092C8;
  font-size: 1.1rem;
  margin-left: 10px;
  margin-right: 10px;
  text-align: right;
}
.counter-container {
  display: flex;
  justify-content: flex-end;
}
.box-row {
  display: flex;
  flex-direction: row;
  padding-bottom: 15px;
  padding-top: 20px;
  border-bottom: 1px solid #e5e5e5;
}
.box-row-title {
  flex: 1;
}
.counter-num {
  display: flex;
  align-items: center;
}
</style>
